import { InputLabelProps } from '@mui/material/InputLabel/InputLabel';
import { SelectProps } from '@mui/material/Select/Select';
import { ReactNode } from 'react';

export const getLinkedInputLabelAndSelectProps = (fieldProps: {
  required?: boolean;
  label: ReactNode;
  selectId: string;
  size?: 'small';
}): {
  inputLabelProps: Partial<InputLabelProps>;
  selectProps: Partial<SelectProps>;
} => {
  const { selectId, label, ...common } = fieldProps;

  const selectLabelId = `${selectId}Label`;

  return {
    inputLabelProps: {
      ...common,
      children: label,
      id: selectLabelId,
    },
    selectProps: {
      ...common,
      label,
      id: selectId,
      labelId: selectLabelId,
    },
  };
};
